module.exports = __webpack_public_path__ + "img/vps_icon.daf1c3c.png";